/* eslint-disable no-underscore-dangle */
import { Box, Typography } from "@mui/material";
import { Map } from "ol";
import React from "react";
import { useTranslation } from "react-i18next";
import { ProjectShapeProgressMapItem } from "../types/mapItems";
import { GenericPopup } from "./GenericPopup";

type ProjectShapePopupProps = { data: ProjectShapeProgressMapItem; map: Map };

export const ProjectShapeProgressPopup = ({
  data,
  map,
}: ProjectShapePopupProps) => {
  // const { t } = useTranslation();
  const {
    Project: projectId,
    // Status,
    mapId,
    type,
    name,
    ...restAttributes
  } = data;
  const { t } = useTranslation();
  const content = React.useMemo(
    () => (
      <Box sx={{ width: "max-content" }}>
        {Object.entries(restAttributes).map((object) => {
          const [key, value] = object as [string, string | number | null];
          if (typeof value === "object") return null;
          return (
            <Typography key={key}>
              {t(`progress-properties:${key}`)}: {value}
            </Typography>
          );
        })}
      </Box>
    ),
    [restAttributes, t],
  );

  return (
    <GenericPopup
      map={map}
      title={<Typography variant="h6">{projectId}</Typography>}
      clicked
      // subheader={`${t("progress-properties:Status")}: ${Status}`}
      content={content}
      headerProps={{
        sx: { paddingBottom: "0px" },
        //   titleTypographyProps: { fontSize: 12 },
      }}
    />
  );
};
